// extracted by mini-css-extract-plugin
export default {"accounts":"sQks6","container":"ZN8fs","avatar":"Djv95","information":"q4jVQ","number":"fpQOv","nickname":"y2zHW"};